import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

const getInitial = (): boolean => {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
};

/**
 * True when the visitor has asked their OS to reduce motion.
 *
 * CSS handles most of this (see `styles.ts`), but JS-driven effects — parallax,
 * randomised flicker delays, autoplay — have to check for themselves.
 */
export const usePrefersReducedMotion = (): boolean => {
  const [reduced, setReduced] = useState<boolean>(getInitial);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;

    const list = window.matchMedia(QUERY);
    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);

    // Safari < 14 only has the deprecated addListener API.
    if (typeof list.addEventListener === "function") {
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    }

    list.addListener(onChange);
    return () => list.removeListener(onChange);
  }, []);

  return reduced;
};

export default usePrefersReducedMotion;
